import { render } from "./SocialPageSelect.vue?vue&type=template&id=13b9860b"
import script from "./SocialPageSelect.vue?vue&type=script&lang=js"
export * from "./SocialPageSelect.vue?vue&type=script&lang=js"

import "./SocialPageSelect.vue?vue&type=style&index=0&id=13b9860b&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__